import { useTranslation } from "react-i18next";

// const { t } = useTranslation()
const Menu = [
    {
      id: 1,
      title: "HTML",
      subtitle:"70%",
      category: "Frontend Development",
      description: "More than 3.5+ years",
      icon: "uil-brackets-curly"
    },
    {
      id: 2,
      title: "CSS",
      subtitle:"60%",
      category: "Frontend Development",
      description: "More than 3.5+ years",
      icon: "uil-brackets-curly"
    },
    {
      id: 3,
      title: "JavaScript",
      subtitle:"50%",
      category: "Frontend Development",
      description: "More than 3.5+ years",
      icon: "uil-brackets-curly"
    },
    {
      id: 4,
      title: "React",
      subtitle:"50%",
      category: "Frontend Development",
      description: "More than 3.5+ years",
      icon: "uil-brackets-curly"
    },
    {
      id: 5,
      title: "Flutter",
      subtitle:"80%",
      category: "Frontend Development",
      description: "More than 3.5+ years",
      icon: "uil-brackets-curly"
    },
    
    {
      id: 6,
      title: "Figma",
      subtitle:"80%",
      category: "UI / UX design",
      description: "More than 4+ years",
      icon: "uil-swatchbook"
    },
    
    {
      id: 7,
      title: "Adobe XD",
      subtitle:"50%",
      category: "UI / UX design",
      description: "More than 4+ years",
      icon: "uil-swatchbook"
    },
    
    {
      id: 8,
      title: "Photoshop",
      subtitle:"50%",
      category: "UI / UX design",
      description: "More than 4+ years",
      icon: "uil-swatchbook"
    },
    
    {
      id: 9,
      title: "Corel Draw",
      subtitle:"70%",
      category: "UI / UX design",
      description: "More than 4+ years",
      icon: "uil-swatchbook"
    },

    {
      id: 10,
      title: "ASP .Net Core",
      subtitle:"60%",
      category: "Backend Development",
      description: "More than 2.2+ years",
      icon: "uil-server-network"
    },

    {
      id: 11,
      title: "SQL",
      subtitle:"50%",
      category: "Backend Development",
      description: "More than 2.2+ years",
      icon: "uil-server-network"
    },

    {
      id: 12,
      title: "Java",
      subtitle:"40%",
      category: "Backend Development",
      description: "More than 2.2+ years",
      icon: "uil-server-network"
    },

    {
      id: 13,
      title: "Dart",
      subtitle:"60%",
      category: "Backend Development",
      description: "More than 2.2+ years",
      icon: "uil-server-network"
    },
    
  ];
  

export default Menu